export default __webpack_public_path__ + "static/media/profile-user-icon-01.8efe593c.png";